import ShipperOrderTable from './container';

export default ShipperOrderTable;
